// Version : 1.0.0
// Author : AGALYA

import HousePhotosActionType from './house-photos.types';

/** ***************** update House Photos Start ************************/
export const updateHousePhotosStart = (housePhotosCredentials: any) => ({
	type: HousePhotosActionType.UPDATE_HOUSE_PHOTOS_START,
	payload: housePhotosCredentials,
});

export const updateHousePhotosSuccess = (housePhotosSuccess: any) => ({
	type: HousePhotosActionType.UPDATE_HOUSE_PHOTOS_SUCCESS,
	payload: housePhotosSuccess,
});

export const updateHousePhotosFailure = (housePhotosFailure: any) => ({
	type: HousePhotosActionType.UPDATE_HOUSE_PHOTOS_FAILURE,
	payload: housePhotosFailure,
});

export const updateHousePhotosResponseResetStart = () => ({
	type: HousePhotosActionType.UPDATE_HOUSE_PHOTOS_RESPONSE_REST_START,
});

export const updateHousePhotosResponseChanged = () => ({
	type: HousePhotosActionType.UPDATE_HOUSE_PHOTOS_RESPONSE_CHANGED,
});
/** ***************** update House Photos End ************************/
